module.exports = __webpack_public_path__ + "static/media/document-duplicate.c8de5af2.svg";